import { editEmail, selectField, sendMockup } from './share-design.actions';
export const checkboxBlockDispatcher = dispatch => ({
  selectField: (field, value) => {
    dispatch(selectField(field, value));
  }
});
export const emailBlockDispatcher = dispatch => ({
  editEmail: email => {
    dispatch(editEmail(email));
  },
  sendMockup: () => {
    dispatch(sendMockup());
  }
});